module.exports = __webpack_public_path__ + "img/116009.2084faa6.png";